import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import CreateEventPopup from '../../../components/popups/create_event_popup'
import CloneEventPopup from '../../../components/popups/clone_event_popup'
import CloneEventCopyOptionsPopup from '../../../components/popups/clone_event_copy_options_popup'
import CloneEventDatesPopup from '../../../components/popups/clone_event_dates_popup'
import CategoryPopup from '../../../components/popups/category_popup'
import ChangeCategoryPopup from '../../../components/popups/change_category_popup'
import ChangeSeasonPopup from '../../../components/popups/change_season_popup'
import ChangeTourPopup from '../../../components/popups/change_tour_popup'
import InvitationListRegistrationPopupSimGolf from '../popups/invitation_list_registration_popup_sim_golf'
import ExistingTimesPopup from '../../../components/popups/existing_times_popup'

const CCPopupsComponentSimGolf = ({
  closePopup,
  createEvent, cloneEvent, categoryPopup,
  cloneEventCopyOptions, advanceToCopyOptions,
  cloneEventDates, advanceToDates,
  invitationListRegistrationPopup,
  changeCategory, changeSeason, changeTour,
  changeLeagueCategory, changeLeagueSeason, changeLeagueTour,
  updateOpenRegistrationStatus,
  userIsAdmin, canCreateDCP, getLeagueFieldData,
  existingTimesPopup, advanceToInvitationList, updateCategoriesSimGolf, createCategory
}) => (
  <Fragment>
    <CreateEventPopup { ...createEvent }
                      onClose={ closePopup }
                      canCreateDCP={ canCreateDCP } />
    <CloneEventPopup { ...cloneEvent }
                     onSave={ advanceToCopyOptions }
                     onClose={ closePopup }
                     canCreateDCP={ canCreateDCP }
                     getLeagueFieldData={ getLeagueFieldData } />
    <CloneEventCopyOptionsPopup { ...cloneEventCopyOptions }
                                onSave={ advanceToDates }
                                onClose={ closePopup } />
    <CloneEventDatesPopup { ...cloneEventDates }
                          onClose={ closePopup } />
    <CategoryPopup { ...categoryPopup }
                   onClose={ closePopup }
                   onUpdate={ updateCategoriesSimGolf }
                   onCreate={ createCategory }
                   userIsAdmin={ userIsAdmin } />
    <ChangeCategoryPopup { ...changeCategory }
                         onClose={ closePopup }
                         onSave={ changeLeagueCategory } />
    <ChangeSeasonPopup { ...changeSeason }
                       onClose={ closePopup }
                       onSave={ changeLeagueSeason } />
    <ChangeTourPopup { ...changeTour }
                     onClose={ closePopup }
                     onSave={ changeLeagueTour } />
    <InvitationListRegistrationPopupSimGolf { ...invitationListRegistrationPopup }
                                     onClose={ closePopup }
                                     onSave={ updateOpenRegistrationStatus } />
    <ExistingTimesPopup { ...existingTimesPopup }
                        onClose={ closePopup }
                        onSave={ advanceToInvitationList } />
  </Fragment>
)

CCPopupsComponentSimGolf.propTypes = {
  closePopup: PropTypes.func.isRequired,
  createEvent: PropTypes.object.isRequired,
  cloneEvent: PropTypes.object.isRequired,
  cloneEventCopyOptions: PropTypes.object.isRequired,
  cloneEventDates: PropTypes.object.isRequired,
  categoryPopup: PropTypes.object.isRequired,
  invitationListRegistrationPopup: PropTypes.object.isRequired,
  changeCategory: PropTypes.object.isRequired,
  changeSeason: PropTypes.object.isRequired,
  changeTour: PropTypes.object.isRequired,
  updateCategoriesSimGolf: PropTypes.func.isRequired,
  createCategory: PropTypes.func.isRequired,
  changeLeagueCategory: PropTypes.func.isRequired,
  changeLeagueSeason: PropTypes.func.isRequired,
  changeLeagueTour: PropTypes.func.isRequired,
  updateOpenRegistrationStatus: PropTypes.func.isRequired,
  advanceToCopyOptions: PropTypes.func.isRequired,
  advanceToDates: PropTypes.func.isRequired,
  userIsAdmin: PropTypes.bool.isRequired,
  canCreateDCP: PropTypes.bool,
  getLeagueFieldData: PropTypes.func,
  existingTimesPopup: PropTypes.object.isRequired,
  advanceToInvitationList: PropTypes.func.isRequired,
}

export default CCPopupsComponentSimGolf